/**
 * 多用于 下拉联想 品牌数据 交互
 */
export default {
  data() {
    return {
      filter: {
        brandName: "", // 品牌名称
        brandId: 0, // 品牌brandId
      },
      searchBrandData: [],
      searchBrandTimer: [],
    };
  },
  watch: {
    "filter.brandName"(val) {
      if (!val) this.filter.brandId = 0;
    },
  },
  methods: {
    // 下拉联想品牌
    $_handleSearchBrand(brandName, cb) {
      if (this.searchBrandTimer) {
        clearTimeout(this.searchBrandTimer);
      }
      this.searchBrandTimer = setTimeout(() => {
        let postData = {
          brandName: brandName,
          pageNow: 1,
          pageSize: 999,
        };
        this.$service.post("getBrands", postData).then(result => {
          if (result.$.checkResult(result, true)) {
            let rows = result.data.rows.splice(0);
            this.searchBrandData = rows;
            cb(rows);
          }
        });
      }, 100);
    },
    // 选择品牌
    $_handleSelectBrand(item) {
      this.filter.brandName = item.brandName;
      this.filter.brandId = item.brandId;
    },
    $_clearSearchBrandData() {
      this.filter.brandName = "";
      this.filter.brandId = 0;
    },
  },
};
